import { render, staticRenderFns } from "./ConsultoraDePrecios.vue?vue&type=template&id=cf2ab4f8&"
import script from "./ConsultoraDePrecios.vue?vue&type=script&lang=js&"
export * from "./ConsultoraDePrecios.vue?vue&type=script&lang=js&"
import style0 from "./ConsultoraDePrecios.vue?vue&type=style&index=0&id=cf2ab4f8&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports